export default __webpack_public_path__ + "static/media/pg.ed6a66a4.svg";